// lib/services/compute/pipelines/compute_pipeline.ts

export default class ComputePipeline {
  pipeline: GPUComputePipeline | null = null;
  bindgroup: GPUBindGroup | null = null;
  thread_count: number;
  workgroup_count: number;
  key: string;

  constructor(key: string,thread_count:number) 
  {
    this.key = key;
    this.thread_count = thread_count;
    const workgroup_size = 32; 
    if(this.thread_count < workgroup_size)
    {
       this.workgroup_count = 1;
    }
    else
    {
     this.workgroup_count = Math.ceil(this.thread_count / workgroup_size);   
    }
  }

  dispatch(encoder: GPUComputePassEncoder): void 
  {
    if (!this.pipeline || !this.bindgroup) return;
    encoder.setPipeline(this.pipeline);
    encoder.setBindGroup(0, this.bindgroup);
    encoder.dispatchWorkgroups(this.workgroup_count);



  }
}